export default "__VITE_ASSET__DEFDCJyE__"